// extracted by mini-css-extract-plugin
export default {"socialButton":"SocialIcon_socialButton__PsQGQ"};